import React, { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import { PopupCircle } from '../Shared';

export interface LayoutProps {
  children: ReactNode;
}

const DefaultLayout = ({ children }: LayoutProps) => {
  return (
    <div>
      <Header />
      {children}
      <Footer />
      <PopupCircle />
    </div>
  );
};

export default DefaultLayout;
